import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';

import getUrl from '@/routes/routes/helpers/getUrl';
import { getRelativeUrl } from '@utils/routing';

import { links, link, linkBrandColor, narrowStyle } from './styles.module.css';
import UserMenuLocaleFlag from '../UserMenuLocaleFlag';

/**
 * User menu presentational component, for logged out users.
 */
const UserMenuLoggedOut = (props) => {
  const {
    className,
    userSelectedLocale,
    onLinkClick,
    narrow,
    location,
  } = props;

  return (
    <div className={[links, narrow ? narrowStyle : '', className].join(' ')}>
      <Link
        to={getUrl.loginPage({
          hash: { source: 'primary_navbar' },
          query: { returnUrl: getRelativeUrl(location) },
        })}
        onClick={onLinkClick}
        className={[linkBrandColor, link].join(' ')}
      >
        Log in
      </Link>
      <UserMenuLocaleFlag userSelectedLocale={userSelectedLocale} />
    </div>
  );
};

UserMenuLoggedOut.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Function called on link click.
   */
  onLinkClick: PropTypes.func,
  /**
   * User selected locale, if any
   */
  userSelectedLocale: PropTypes.string,
  /**
   * Injected location from react router
   */
  location: PropTypes.shape({}),
};

UserMenuLoggedOut.defaultProps = {
  className: '',
  onLinkClick: () => {},
  userSelectedLocale: undefined,
  location: {},
};

export default withRouter(UserMenuLoggedOut);
